import clsx from 'clsx';
import { PlusCircleMutedIcon } from '../icons';
import styles from './AddRowButton.module.css';

export function AddRowButton({ label, onClick, disabled = false, className = '' }) {
  return (
    <button
      type="button"
      className={clsx(styles.button, disabled && styles.disabled, className)}
      onClick={onClick}
      disabled={disabled}
    >
      <PlusCircleMutedIcon className={clsx(styles.icon)} aria-hidden />
      <span>{label}</span>
    </button>
  );
}
